// extracted by mini-css-extract-plugin
export default {"contact":"Support_contact__+Bgwx","info":"Support_info__HUUnI"};